<template>
  <b-card no-body class="mb-2">
    <b-card-body>

      <!-- Period quick-select -->
      <div class="mb-1">
        <p class="small font-weight-bold text-uppercase text-muted mb-50">Period</p>
        <b-button
          v-for="p in presets"
          :key="p.value"
          size="sm"
          class="mr-25 mb-25"
          :variant="activePeriod === p.value ? 'primary' : 'outline-primary'"
          @click="$emit('preset', p.value)"
        >
          {{ p.label }}
        </b-button>
      </div>

      <b-row>
        <!-- From -->
        <b-col cols="6" md="2" class="mb-1">
          <label class="small font-weight-bold text-muted mb-25 d-block">From</label>
          <b-form-input
            :value="filterFrom"
            type="date"
            size="sm"
            @change="v => $emit('update-filter', 'filterFrom', v) || $emit('update-filter', 'activePeriod', 'custom')"
          />
        </b-col>

        <!-- To -->
        <b-col cols="6" md="2" class="mb-1">
          <label class="small font-weight-bold text-muted mb-25 d-block">To</label>
          <b-form-input
            :value="filterTo"
            type="date"
            size="sm"
            @change="v => $emit('update-filter', 'filterTo', v) || $emit('update-filter', 'activePeriod', 'custom')"
          />
        </b-col>

        <!-- Vertical -->
        <b-col cols="6" md="2" class="mb-1">
          <label class="small font-weight-bold text-muted mb-25 d-block">Vertical</label>
          <b-form-select
            :value="filterVertical"
            :options="verticalOptions"
            size="sm"
            @change="v => $emit('update-filter', 'filterVertical', v)"
          />
        </b-col>

        <!-- Recruiter search (hidden when scope = self) -->
        <b-col v-if="!hideRecruiterFilter" cols="6" md="2" class="mb-1">
          <label class="small font-weight-bold text-muted mb-25 d-block">Recruiter</label>
          <b-form-input
            :value="recruiterSearch"
            size="sm"
            placeholder="Search name…"
            @input="v => $emit('update-filter', 'recruiterSearch', v)"
          />
        </b-col>

        <!-- Team Lead (hidden for self / team scope) -->
        <b-col v-if="!hideTeamLeadFilter" cols="6" md="2" class="mb-1">
          <label class="small font-weight-bold text-muted mb-25 d-block">Team Lead</label>
          <b-form-select
            :value="filterTeamLead"
            :options="teamLeadOptions"
            size="sm"
            @change="v => $emit('update-filter', 'filterTeamLead', v)"
          />
        </b-col>

        <!-- Active only + Apply -->
        <b-col cols="12" sm="6" md="2" class="mb-1 d-flex flex-column justify-content-end">
          <b-form-checkbox
            :checked="activeOnly"
            switch
            class="mb-25"
            @change="v => $emit('update-filter', 'activeOnly', v)"
          >
            <span class="small font-weight-bold text-muted">Active only</span>
          </b-form-checkbox>
          <b-button
            variant="primary"
            size="sm"
            block
            :disabled="loading"
            @click="$emit('apply')"
          >
            <b-spinner v-if="loading" small class="mr-50" />
            Apply Filters
          </b-button>
        </b-col>
      </b-row>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody,
  BRow, BCol,
  BButton, BSpinner,
  BFormInput, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'

export default {
  name: 'PerfFilterBar',
  components: {
    BCard, BCardBody,
    BRow, BCol,
    BButton, BSpinner,
    BFormInput, BFormSelect, BFormCheckbox,
  },
  props: {
    filterFrom:      { type: String, default: '' },
    filterTo:        { type: String, default: '' },
    filterVertical:  { type: String, default: 'Both' },
    filterTeamLead:  { type: String, default: '' },
    recruiterSearch: { type: String, default: '' },
    activeOnly:      { type: Boolean, default: false },
    activePeriod:    { type: String, default: 'last_month' },
    loading:              { type: Boolean, default: false },
    presets:              { type: Array, default: () => [] },
    verticalOptions:      { type: Array, default: () => [] },
    teamLeadOptions:      { type: Array, default: () => [] },
    hideRecruiterFilter:  { type: Boolean, default: false },
    hideTeamLeadFilter:   { type: Boolean, default: false },
  },
  // Emits: 'preset' (value), 'update-filter' (key, value), 'apply'
}
</script>
